export function InterventionsListPage() {
  return (
    <div>
      {/* TODO: Interventions list */}
    </div>
  );
}
